import React, { useRef, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import './ExchangeGamesGridList.scss'
import { IonList, IonListHeader } from '@ionic/react'
import { useHistory } from 'react-router'
import { setLoginNew } from '../../store/LoginNew/loginNew.slice'
import { USER_DATA } from '../../config/app.config'
import { toastr } from 'react-redux-toastr'
import {
  requestCasinoPoint,
  requestQTechCasinoID,
} from '../../store/liveCasino/liveCasino.thunks'
import { setSlotCasinoPopUp } from '../../store/slotCasinoPopUp/slotCasinoPopUp.slice'

const PopularGameGrid = ({ itemHeaderData, itemsData, name }) => {
  const history = useHistory()
  const auth = useSelector((state) => state.auth)
  const dispatch = useDispatch()
  const slider = useRef(null)
  const [isDown, setIsDown] = useState(false)
  const [isSlide, setIsSlide] = useState(false)
  const [startX, setStartX] = useState('')
  const [scrollLeft, setScrollLeft] = useState('')

  const renderHeader = () => {
    return (
      <IonListHeader className="inplay-item-list-exchange__header ">
        <div className="inplay-item-list-exchange__header-content">
          <div className="inplay-item-list-exchange__header-logo">
            <i
              className={`inplay-content__logo-icon inplay-content__logo-icon--exchange-games inplay-color-icon`}
            />
            {/* {itemHeaderData?.name} */}
            <span>{name}</span>
          </div>
        </div>
      </IonListHeader>
    )
  }

  const onSelectGame = (id, code) => {
    if (auth) {
      let data = { gameId: id, providerCode: code }
      dispatch(requestQTechCasinoID(data))
      history.push(`/live_casino_slot/${id}`)
    } else {
      dispatch(setLoginNew(true))
    }
  }

  const handleNavigate = (id, code, item) => {
    let user = localStorage.getItem(USER_DATA)
    let userData = user ? JSON.parse(user) : {}
    if (userData?.is_demo) {
      toastr.error('', 'Please login from your read ID.')
      return
    }
    if (item?.redirect) {
      history.push(item.redirect)
    } else {
      onSelectGame(id, code)
    }

    dispatch(setSlotCasinoPopUp(true))
    dispatch(requestCasinoPoint())
  }

  return (
    <IonList className="inplay-item-list_exchangeGames">
      {itemHeaderData ? renderHeader() : null}
      <div
        className="exchangeGames-content"
        ref={slider}
        onMouseDown={(e) => {
          setIsDown(true)
          setStartX(e.pageX - slider.current.offsetLeft)
          setScrollLeft(slider.current.scrollLeft)
        }}
        onMouseUp={() => {
          if (isSlide) {
            setTimeout(() => setIsSlide(false), 500)
          }
          setIsDown(false)
        }}
        onMouseMove={(e) => {
          if (!isDown) return
          e.preventDefault()
          setIsSlide(true)
          const x = e.pageX - slider.current.offsetLeft
          const walk = (x - startX) * 3 //scroll-fast
          slider.current.scrollLeft = scrollLeft - walk
        }}
        onMouseLeave={() => {
          setIsDown(false)
          setIsSlide(false)
        }}
      >
        {itemsData &&
          itemsData.map((item, index) => {
            return (
              item?.gameId && (
                <div
                  className="exchangeGames-item"
                  key={index}
                  style={{ backgroundColor: `${item?.img}` }}
                  onClick={
                    isSlide
                      ? () => {}
                      : () => {
                          if (auth) {
                            handleNavigate(item?.gameId, item?.tableId, item)
                          } else {
                            dispatch(setLoginNew(true))
                          }
                        }
                  }
                >
                  <div
                    className="exchangeGames-img-body"
                    style={{
                      backgroundImage: `url(${item?.img})`,
                    }}
                  ></div>
                </div>
              )
            )
          })}
      </div>
    </IonList>
  )
}

export default PopularGameGrid
